import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjszp2vv28: FaireProductEntity = {
  token: "p_yjszp2vv28",
  type: "product",
  name: "C.C Baby Solid Ribbed Pom Beanie and Mitten Glove",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl: "https://cdn.faire.com/fastly/65052663a09e80bd58e955c22be5c49b529845148f36069141d7e83f83b7339c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5a82919ab2a9caa92c641367bc08275bf874f2520c707ce7cd64f854cb4cfc6.jpeg",
    "https://cdn.faire.com/fastly/9b4af02c7f17fb1b96c896a6943714c07da79151ecb619d111b6077cf2588563.jpeg",
    "https://cdn.faire.com/fastly/5da74844aa5578d1f33fd30ede2fc239d721630fa2aaafa2c7c478e9aec955d4.jpeg",
    "https://cdn.faire.com/fastly/14108c8a0c32c1481e67ec6c97ce4de1e2b8b93c1d0ce5c8d19bf0a40cdf233b.jpeg",
    "https://cdn.faire.com/fastly/7b098009f4171ca8d46d9cfcd0e2b1cc1b4cc91aee47b8937c6d2b4f67a507f4.jpeg",
    "https://cdn.faire.com/fastly/74b8bb13f28d488bb3ff368260d63b5d454ac5927636cd6cadfbee9cc977a2ed.jpeg",
    "https://cdn.faire.com/fastly/d05bdbe425c2056b3fbf084f29330b04b9d8746637a2e23779344fbcc6f8d549.jpeg",
    "https://cdn.faire.com/fastly/d56c07d8cb9dfe02ad3a3ffba79ef00ede762a61df2206b330d41fa4ff37fdb9.jpeg",
    "https://cdn.faire.com/fastly/c8fdef56cbd890dfadbdc55913239974babb6efaa034985ac9cc6c0b4d5c034e.jpeg",
    "https://cdn.faire.com/fastly/a9e122e7667a0b3ed90719e50b023b73eecc2791c2bf97bcaeee5763b5275562.jpeg"
  ],
  priceDollars: 18.36,
  description: "C.C Baby Solid Ribbed Pom Beanie and Mitten Glove\n0-9 Month\n100% Acrylic",
  tags: [],
  msrpDollars: 36.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:08.921Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
